import { render, staticRenderFns } from "./FloatingButton.vue?vue&type=template&id=09f56307&scoped=true&"
import script from "./FloatingButton.vue?vue&type=script&lang=js&"
export * from "./FloatingButton.vue?vue&type=script&lang=js&"
import style0 from "./FloatingButton.vue?vue&type=style&index=0&id=09f56307&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f56307",
  null
  
)

export default component.exports